"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routeUrls = void 0;
// TODO later it probably deserves splitting, now it's fine
exports.routeUrls = {
    audienceTargeting: () => '/audience-targeting',
    dashboard: () => '/campaign-dashboard',
    drops: () => '/drops',
    creatorsTwitch: (mnemonicId) => `/creators/${mnemonicId}`,
    creatorsYoutube: (mnemonicId) => `/creators/yt/${mnemonicId}`,
    creatorsTiktok: (mnemonicId) => `/creators/tiktok/${mnemonicId}`,
    creatorsFacebook: (mnemonicId) => `/creators/facebook/${mnemonicId}`,
    drop: (mnemonicId) => `/e/${mnemonicId}`,
};
